import { render, staticRenderFns } from "./UploadSimcard.vue?vue&type=template&id=509d0d4c&"
import script from "./UploadSimcard.vue?vue&type=script&lang=js&"
export * from "./UploadSimcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports